import * as types from './mutation-types'

export const mutations = {
    [types.ROLE_ID] (state, payload) {
        if (!localStorage.getItem('role_id')) {
            state.role_id = payload
        } else {
            state.role_id = localStorage.getItem('role_id')
        }
    },

    [types.SESSION_USER] (state, payload) {
        state.session_user = payload
    },

    [types.BIODATA_USER] (state, payload) {
        state.biodata_user = payload
    },
    
    [types.SET_API_TOKEN] (state, payload) {
        if (!localStorage.getItem("api_token")) {
            state.api_token = payload
        } else {
            state.api_token = localStorage.getItem("api_token")
        }
    },

    [types.SET_SESSION_ID](state, payload) {
        if (!localStorage.getItem("session_id")) {
            state.session_id = payload
        } else {
            state.session_id = localStorage.getItem("session_id")
        }
    }
}


// WEBPACK FOOTER //
// ./src/store/mutations.js